export default {
  'header:account': 'Account',
  'header:account:greeting': 'Hoi, {firstName}',
  'header:cart': 'Winkelwagen',
  'header:search': 'Zoeken',
  'header:pet-profile': 'Jouw hond',
  'header:pet-profile-cat': 'Jouw kat',
  'header:pet-profile:mine': 'Mijn hond',
  'header:pet-profile-cat:mine': 'Mijn kat',
  'header:discount': 'Korting',
  'header:navigation-dogs': 'Honden',
  'header:navigation-cats': 'Katten',
  'header:navigation:mobile:back': 'Terug',
  'header:navigation:mobile:magazine': 'Magazine',
  'header:navigation:mobile:consulting': 'Advies',
  'header:usp:trusted-shop': '4,89/5,0 ,,Zeer goed”- bij meer dan 4.856 beoordelingen',
  'header:usp:faq-help': 'FAQ & hulp',
  'header:usp:free-shipping': 'Gratis verzending vanaf € 50',
  'header:usp:recipes': 'Uitgekozen en lekkere recepten',
  'header:usp:acceptance': 'Bijzonder hoge acceptatie',
  'header:usp:no-grains': '100% echt vlees - 0% granen',
  'header:usp:ratings': '98% positieve beoordelingen: meer dan 55.000 blije viervoeters',
  'header:usp:donations': '1000% dierenliefde - regelmatige donaties voor dieren in nood',
  'header:usp:good-choice': 'Goede keuze! Jouw viervoeter zal je dankbaar zijn.',
  'header:search:placeholder': 'Voeding vinden',
  'header:search:last-queries': 'LAATSTE ZOEKOPDRACHTEN',
  'header:search:delete': 'WISSEN',
  'header:promobar:promotion-ended': 'Actie beëindigd',

  'header:usp:free-shipping:EC': 'Gratis verzending vanaf € 60 ',
  'header:usp:free-shipping:NC': '<b> Gratis verzending voor nieuwe klanten </b>',
  'header:tastyguarantee:money-back:modal:title': 'Pets Deli lost voedingsproblemen op - bewezen.',
  'header:tastyguarantee:money-back:modal:sub-title':
    'Ons motto: <b>Smaakt niet, bestaat niet!</b> Mocht het jouw viervoeter tegen de verwachting in toch niet smaken, dan krijg je van ons een gratis voedingsalternatief.',
  'header:tastyguarantee:money-back:modal:list-title': 'Zo eenvoudig gaat het:',
  'header:tastyguarantee:money-back:modal:step-1':
    'Vul gewoon ons contactformulier in, dat je hier vindt. Gebruik bij problemen alstublieft “Lekker Garantie” <a>Aanvraag indienen - PETS DELI</a>',
  'header:tastyguarantee:money-back:modal:step-2':
    'Ontvang een gratis voedingsadvies van onze voedingsexperts om het juiste alternatieve product te vinden dat bij jullie behoeften past.',
  'header:tastyguarantee:money-back:modal:step-3':
    'Wij zorgen ervoor dat je jouw nieuwe product zo snel mogelijk toegestuurd krijgt.',
  'header:usp:test:text-1': 'Gratis levering voor nieuwe klanten',
  'header:usp:test:text-2': '91% opgeloste voedingsproblemen',
  'header:usp:test:text-3': '10% korting op bespaarabonnement',
  'header:usp:test:text-4': 'Meer dan 98.654 tevreden klanten',
  'header:language-selector:label': 'Taal: {language}',
  'header:language-selector:title': 'Taal',
  'header:language-selector:aria-label': 'Taal selecteren',
};
